import * as Yup from 'yup'

export const validation = {
    id_forma_pago:      Yup.string().required('La forma de pago es obligatoria'),
    cantidad_matricula: Yup.number().typeError('El precio de la matricula es obligatorio.').required('El precio de la matricula es obligatorio.'),
    cantidad:           Yup.number().typeError('La cantidad es obligatoria.').required('La cantidad es obligatoria.'),
}

export const validationSchema = Yup.object().shape(validation)